/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { CookieService } from 'app/shared/services/cookie.service';

export class Constants {
	public static Offline = class {
		public static KeyOfflineStatus = 'orbittickets_offline-status';
		public static IsOffline = 'offline';
		public static IsOnline = 'online';

		public static MaxFileSystemMb = 500 * 1024 * 1024;
		public static KeyInspectionPrefix = 'inspection-';

		public static KeyDevelopmentInfoPrefix = 'development-';

		public static KeyPendingInspectionPollRequests = 'pending-inspection-poll-requests';
		public static PollPauseMilliseconds = 5 * 1000;
		public static PollPauseLongerMilliseconds = 120 * 1000;

		public static KeyPendingInspectionSyncRequests = 'pending-inspection-sync-requests';
		public static SyncPauseMilliseconds = 5 * 1000;
		public static SyncPauseLongerMilliseconds = 120 * 1000;
	};

	public static LocalStorage = class {
		public static DatabaseName = 'WH-LocalStorage';
		public static Version = 1.0;
		public static Description = 'Database used by the application to store information needed for offline working';
		public static Size = 52428800;
		public static PurgeDays = 14;
		public static KeyAccessToken = 'orbittickets_accessToken';
		public static KeyRefreshToken = 'orbittickets_refreshToken';
		public static RedirectUrl = 'orbittickets_redirectUrl';
	};

	public static Audit = class {
		public static KeyAuditEntryPrefix = 'audit-';
		public static KeyAuditEntryFrequency = 'DD-MMM-YYYY-HH-mm';
	};

	public static FileSystem = class {
		public static PurgeDays = 60;

		public static FileError = class {
			public static QUOTA_EXCEEDED_ERR = 'QuotaExceededError';
			public static NOT_FOUND_ERR = 'NOT_FOUND_ERR';
			public static SECURITY_ERR = 'SECURITY_ERR';
			public static INVALID_MODIFICATION_ERR = 'INVALID_MODIFICATION_ERR';
			public static INVALID_STATE_ERR = 'INVALID_STATE_ERR';
		};

		public static FileReaderReadyState = class {
			public static EMPTY = 0;
			public static LOADING = 1;
			public static DONE = 2;
		};
	};

	public static Cookies = class {
		public static KeyLoggedInUserId = 'orbittickets_loggedInUserId';
		public static KeyLoggedInUserType = 'orbittickets_loggedInUserType';
		public static KeyLoggedInUserName = 'orbittickets_loggedInUserName';
		public static KeyLoggedInFullName = 'orbittickets_loggedInFullName';
		public static KeyUiState = 'orbittickets_uiState';
		public static KeyDeviceId = 'orbittickets_deviceId';
		public static KeyOrganiserId = 'orbittickets_organiserId';
	};

	public static Evidence = class {
		public static MaxThumbnailWidth = 200;
	};

	public static ImageSelector = class {
		public static emptyImage =
			'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';
	};

	public static EditorSettings = class {
		public static FullSettings(cookieService: CookieService) {
			return {
				height: 500,
				menubar: false,
				browser_spellcheck: true,
				contextmenu: false,
				file_picker_types: 'file image media',
				tabindex: 1,
				file_picker_callback: function (cb, value, meta) {
					var input = document.createElement('input');
					input.setAttribute('type', 'file');
					input.setAttribute('accept', 'image/*');
					/*
          Note: In modern browsers input[type="file"] is functional without
          even adding it to the DOM, but that might not be the case in some older
          or quirky browsers like IE, so you might want to add it to the DOM
          just in case, and visually hide it. And do not forget do remove it
          once you do not need it anymore.
        */

					input.onchange = function () {
						var file = input.files[0];
						let tinymce = window['tinymce'];
						var reader = new FileReader();
						reader.onload = function () {
							/*
              Note: Now we need to register the blob in TinyMCEs image blob
              registry. In the next release this part hopefully won't be
              necessary, as we are looking to handle it internally.
            */
							var id = 'blobid' + new Date().getTime();
							var blobCache = tinymce.activeEditor.editorUpload.blobCache;
							var base64 = (<string>reader.result).split(',')[1];
							var blobInfo = blobCache.create(id, file, base64);
							blobCache.add(blobInfo);

							/* call the callback and populate the Title field with the file name */
							cb(blobInfo.blobUri(), { title: file.name });
						};
						reader.readAsDataURL(file);
					};

					input.click();
				},
				plugins: ['advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen', 'insertdatetime', 'media', 'table', 'powerpaste', 'code', 'help', 'wordcount'],
				toolbar:
					'fullscreen | undo redo | fontfamily fontsize | blocks | image customtimestamp searchreplace | link anchor | bold italic underline strikethrough forecolor backcolor  | \
    alignleft aligncenter alignright alignjustify | \
    bullist numlist outdent indent | removeformat | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | code | help',
				insertdatetime_formats: ['%d/%m/%Y @ %H:%M:%S'],
				content_css: [
					'/assets/scss/_fonts.scss',
					'https://fonts.googleapis.com/css2?' +
						'family=Open+Sans' +
						'&family=Exo' +
						'&family=Oswald' +
						'&family=Comfortaa' +
						'&family=Roboto+Slab' +
						'&family=Lora' +
						'&family=Playfair+Display' +
						'&family=Kalam' +
						'&family=Amita' +
						'&family=Oregano' +
						'&family=Life+Savers' +
						'&family=Lobster',
				],
				font_family_formats: `
	  F37 Analog Bold=F37Analog-Bold,sans-serif;
	  Manrope=Manrope,sans-serif;
	  Open Sans=Open Sans,sans-serif;
	  Exo=Exo,sans-serif;
	  Arial=Arial,Helvetica,sans-serif;
	  Oswald=Oswald,sans-serif;
	  Comfortaa=Comfortaa,cursive;
	  Roboto Slab=Roboto Slab,serif;
	  Times New Roman=Times New Roman,Times,serif;
	  Lora=Lora,serif;
	  Playfair Display=Playfair Display,serif;
	  Kalam=Kalam,cursive;
	  Amita=Amita,cursive;
	  Oregano=Oregano,cursive;
	  Life Savers=Life Savers,cursive;
	  Lobster=Lobster,cursive;
	  `,
				content_style: `
	        body { font-family: Arial, sans-serif; }
    `.replace(/\s+/g, ' '),
				setup: function (editor) {
					//var customUsertimeFunction = cookieService.getUserDateTime;
					const customUsertimeFunction = cookieService.getUserDateTime.bind(cookieService);

					editor.ui.registry.addButton('customtimestamp', {
						icon: 'insert-time',
						tooltip: 'Insert Timestamp',
						disabled: true,
						onAction: function (_) {
							editor.insertContent(customUsertimeFunction(new Date()));
						},
						onSetup: function (buttonApi) {
							var editorEventCallback = function (eventApi) {
								buttonApi.setEnabled(eventApi.element.nodeName.toLowerCase() !== 'time');
							};
							editor.on('NodeChange', editorEventCallback);

							/* onSetup should always return the unbind handlers */
							return function (buttonApi) {
								editor.off('NodeChange', editorEventCallback);
							};
						},
					});
				},
			};
		}
		public static BasicSettings(cookieService: CookieService) {
			return {
				height: 500,
				user: 'damo b',
				menubar: false,
				browser_spellcheck: true,
				contextmenu: false,
				plugins: ['advlist', 'autolink', 'lists', 'charmap', 'preview', 'searchreplace', 'fullscreen', 'powerpaste', 'wordcount', 'code', 'help'],
				toolbar:
					'fullscreen | undo redo searchreplace | bold italic underline strikethrough | \
          bullist numlist outdent indent | customtimestamp | code | help',
				setup: function (editor) {
					var customUsertimeFunction = cookieService.getUserDateTime;

					editor.ui.registry.addButton('customtimestamp', {
						icon: 'insert-time',
						tooltip: 'Insert Timestamp',
						disabled: true,
						onAction: function (_) {
							editor.insertContent(customUsertimeFunction(new Date()));
						},
						onSetup: function (buttonApi) {
							var editorEventCallback = function (eventApi) {
								buttonApi.setEnabled(eventApi.element.nodeName.toLowerCase() !== 'time');
							};
							editor.on('NodeChange', editorEventCallback);

							/* onSetup should always return the unbind handlers */
							return function (buttonApi) {
								editor.off('NodeChange', editorEventCallback);
							};
						},
					});
				},
			};
		}
	};
}
